import * as signalR from "@microsoft/signalr";

/** Fallback for tabs that miss the hub push (reconnect gap, hub unavailable) — matches the plan's "60s poll + hub wake". */
var POLL_INTERVAL_MS = 60000;

function updateBadge(badge, count) {
  var safeCount = typeof count === "number" && count > 0 ? count : 0;
  badge.textContent = safeCount > 99 ? "99+" : String(safeCount);
  badge.hidden = safeCount <= 0;
  badge.setAttribute("data-count", String(safeCount));
}

function fetchUnreadCount(badge) {
  fetch("/api/community/notifications/unread-count", { credentials: "same-origin" })
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(function (data) {
      if (data && data.success) {
        updateBadge(badge, data.count);
      }
    })
    .catch(function () {
      // Transient failure — the next poll or hub wake will catch it up.
    });
}

function start() {
  var badge = document.querySelector("[data-community-unread-badge]");
  if (!badge) return;

  setInterval(function () { fetchUnreadCount(badge); }, POLL_INTERVAL_MS);

  var connection = new signalR.HubConnectionBuilder()
    .withUrl("/hubs/community")
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  connection.on("communityUnreadChanged", function () { fetchUnreadCount(badge); });
  connection.onreconnected(function () { fetchUnreadCount(badge); });

  connection.start().catch(function (error) {
    console.warn("SignalR community hub connection failed:", error);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
